<template>
  <IconLucideLink />
</template>
